import { defaultEditor } from './default';

const basePresets = {
  ...defaultEditor,
};

export default basePresets;
